import { formatDateTime, formatDecimalUnit } from '@/common/utils/formatters'
import { CompanyEquipmentUsageDeclarationsHistoryData } from '../../types/companyEquipmentUsageDeclarationsHistory.type'
import { DownloadIcon } from 'lucide-react'

export class EquipmentUsageDeclarationsHistoryTransformer {
  static tableTransformer() {
    return (usageDeclarations: CompanyEquipmentUsageDeclarationsHistoryData[]) => {
      return usageDeclarations.map((usageDeclaration) => {
        return {
          transaction_id: usageDeclaration.creator?.protocol_number,
          author: usageDeclaration.creator?.buyer?.full_name,
          product_category: usageDeclaration?.category?.display_name,
          created_at: usageDeclaration.created_at
            ? formatDateTime(new Date(usageDeclaration.created_at))
            : '',
          value: usageDeclaration.value
            ? formatDecimalUnit(usageDeclaration.value, usageDeclaration?.creator?.current_equipment_usage_unit, false, 0)
            : '',
          reason: usageDeclaration.reason,
          actions: (
            <div className='flex items-center justify-center gap-3'>
              {usageDeclaration.file?.url && (
                <a href={usageDeclaration.file?.url} target='_blank' className="flex items-center gap-1 text-white-900 hover:text-blue-800 transition-colors">
                  <DownloadIcon strokeWidth={1} />
                </a>
              )}
            </div>
          ),
        }
      })
    }
  }
}

